module.exports = "<p>\n  organization-details works!\n</p>\n"